<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		ParameterCard,
		IconButton,
		Text,
		ControlsContainer,
		Stack,
		ParameterCardV2,
		Container,
		Button,
	} from '@Shelly/shelly-design-system';
	import { temp_schemes } from 'src/stores/lists/scenes-derived';
	import { copy } from '../../../helpers/copy_text';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import ThermostatDeleteModal from 'src/components/Drawer/ThermostatDrawer/ThermostatDeleteModal.svelte';
	import { canManageHomeEntities } from 'src/helpers/houses/homes_helpers';
	import { homes } from 'src/stores/account/home';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
	import SharedHomeOwnerManagedAlert from 'src/components/SharedHome/SharedHomeOwnerManagedAlert.svelte';

	export let id;
	export let value;

	let showDeleteThermostatModal = false;

	$: isSharedHomeActive = isActiveHomeShared($homes.list);

	$: thermostat_json = $temp_schemes[id];
	$: enabled = thermostat_json._enabled;
	$: internal_temperature = value || null;
	// $: threshold = thermostat_status?.threshold || thermostat_json?.ths;
</script>

<Stack gap="s">
	{#if enabled}
		<!-- <ParameterCard
		class="mt-m"
		icon="fa-solid fa-temperature-three-quarters"
		title={`${threshold} ${units}`}
		description={'Threshold value'}
	/> -->

		{#if $showNewLayout}
			<ParameterCardV2
				size="s"
				icon="fat fa-temperature-three-quarters"
				title={internal_temperature === null
					? $format('no_data_yet_msg', { default: 'No data yet' })
					: `${internal_temperature}`}
				description={$format('label_sensor_temp', {
					default: 'Sensor temperature',
				})}
			/>
		{:else}
			<ParameterCard
				icon="fa-solid fa-temperature-three-quarters"
				title={internal_temperature === null
					? $format('no_data_yet_msg', { default: 'No data yet' })
					: `${internal_temperature}`}
				description={$format('label_sensor_temp', {
					default: 'Sensor temperature',
				})}
			/>
		{/if}
	{/if}

	{#if $showNewLayout}
		<Container backgroundColor="color-0">
			<Text styleType="label-large" class="text-center mb-s-plus">
				{$format('temp_scheme_id', { default: 'Temperature scheme ID' })}
			</Text>
			<div class="d-flex justify-content-center align-items-center">
				<Text class="text-break-all text-center" styleType="body">{id}</Text>

				<IconButton
					aria-label={$format('button_copy_id', { default: 'Copy ID' })}
					class="ml-s"
					icon="fas fa-copy"
					on:click={() =>
						copy(
							id,
							$format('copied_successfully', {
								default: 'Copied successfully!',
							}),
						)}
				/>
			</div>
		</Container>

		{#if isSharedHomeActive}
			<SharedHomeOwnerManagedAlert context="delete_entity" />
		{/if}
		<Button
			size="m"
			width="full"
			variant="danger"
			icon="fas fa-trash"
			disabled={isSharedHomeActive}
			aria-label={$format('button_delete_thermostat', {
				default: 'Delete thermostat',
			})}
			on:click={() => (showDeleteThermostatModal = true)}
		>
			{$format('button_delete_thermostat', {
				default: 'Delete thermostat',
			})}
		</Button>
	{:else}
		<ControlsContainer size="s" color={$showNewLayout ? 'color-1' : undefined}>
			<svelte:fragment slot="first">
				<Text
					styleType="body-small"
					class="text-bold align-self-center text-capitalize text-left"
				>
					{$format('temp_scheme_id', { default: 'Temperature scheme ID' })}
				</Text>
				<hr class="mt-s mb-s" />
				<div class="d-flex justify-content-between align-items-center">
					<Text class="text-break-all" styleType="body-small">{id}</Text>

					<IconButton
						aria-label={$format('button_copy_id', { default: 'Copy ID' })}
						class="ml-s"
						icon="fas fa-copy"
						on:click={() =>
							copy(
								id,
								$format('copied_successfully', {
									default: 'Copied successfully!',
								}),
							)}
					/>
				</div>
			</svelte:fragment>
		</ControlsContainer>
	{/if}
</Stack>

<ThermostatDeleteModal
	bind:showDeleteThermostatModal
	thermostat_id={id}
	thermostat_name={thermostat_json._meta.name}
/>
